type ProgressBarProps = React.HTMLAttributes<HTMLDivElement> & {
  max: number
  progress: number
}

export const ProgressBar = ({ max, progress, ...props }: ProgressBarProps) => {
  const currentWidth = (progress / max) * 100

  return (
    <div
      className={`flex relative gap-2 ProgressBar ${props.className}`}
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={max}
    >
      <div
        className={`absolute left-0 w-full h-2 rounded-full bg-mydra-gray`}
      />
      <div
        className={`absolute left-0 h-2 rounded-full bg-mydra-black`}
        style={{ width: `${currentWidth}%` }}
      />
    </div>
  )
}
